import React from "react";
import CardHeader from "./CardHeader/cardHeader";
import CardPartners from "./CardPartners/cardPartners";
import CardSearch from "./CardSearch/cardSearch";


function PartnersScreen(props) {
    return (
        <>
            <CardHeader />
            <CardSearch />
            <CardPartners />
        </>
    )
}

export default PartnersScreen
